module.exports = __webpack_public_path__ + "img/banner.e5779ff9.png";